module.exports = __webpack_public_path__ + "img/markPoint1.c601725a.png";